export default __webpack_public_path__ + "static/media/bitcoin-white.99d362c2.svg";